import { memo, type ReactNode } from "react";
import Avatar from "src/components/Avatar";
import Touchable from "src/components/Touchable";
import { ChevronDown, ChevronUp } from "src/icons";
import { cn } from "src/utilities/shadcnUtils";

import type { DropdownTriggerProps } from "../Dropdown";

const AccountDropdownButton = ({
  onClick,
  open,
  initials,
  className,
}: DropdownTriggerProps & { initials: string | ReactNode; className?: string }) => {
  return (
    <Touchable
      className={cn(
        "flex items-center gap-1 rounded-full border border-border py-1 pl-1 pr-1.5 transition-colors hover:bg-muted",
        className
      )}
      onClick={onClick}
    >
      <Avatar className="w-7 h-7 text-xxs rounded-full" active={open}>
        {initials}
      </Avatar>
      {open ? (
        <ChevronUp className="text-muted-foreground min-w-4 min-h-4" />
      ) : (
        <ChevronDown className="text-muted-foreground min-w-4 min-h-4" />
      )}
    </Touchable>
  );
};

export default memo(AccountDropdownButton);
